import { Injectable } from '@angular/core';
import { Code } from '../model/Code';
import { DoorLock } from '../model/DoorLock';
import { DoorTimer } from '../model/DoorTimer';
import { CodificationService } from './../common-services/codification.service';
import { Game } from './../model/Game';
import { LockService } from './lock.service';
import { TimerService } from './timer.service';

@Injectable({
  providedIn: 'root'
})
export class CodeGeneratorService {


  constructor(private lockService: LockService, private timerService: TimerService, private codificationService: CodificationService) { }


  public generateCode(baseGame?: Game): Promise<Game> {

    const timer = baseGame && baseGame.timer ? baseGame.timer.timer : this.timerService.getRandom();
    const lock = baseGame && baseGame.lock ? baseGame.lock.lock : this.lockService.getRandom();
    const codification = baseGame && baseGame.lock.codification ? baseGame.lock.codification : this.codificationService.getRandom();
    let codes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    lock.codification = codification;
    //lock.tries = 1;
    let numbersCopy: number[] = [...codes.slice(0, codification.size - 1)];
    const combination = [];
    for (let d = 1; d <= lock.digits; d++) {
      let pos = Math.round(Math.random() * (numbersCopy.length - 1));
      combination.push(numbersCopy.splice(pos, 1)[0]);
    }
    const code = new Code(combination);
    if (!baseGame) timer.time = 90000 * lock.digits;
    const game = new Game(1, new DoorTimer(1, timer), new DoorLock(1, lock, 10000, code));
    return Promise.resolve(game);
  }
}
